import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-4" };
const _hoisted_2 = { class: "text-lg font-semibold uppercase" };
const _hoisted_3 = { class: "uppercase" };
const _hoisted_4 = { class: "grid grid-auto-rows grid-cols-4 gap-4" };
const _hoisted_5 = { class: "uppercase" };
const _hoisted_6 = { class: "error-text" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", null, "Port number", -1);
const _hoisted_8 = { class: "error-text" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", null, "User name", -1);
const _hoisted_10 = { class: "error-text" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, "Password", -1);
const _hoisted_12 = { class: "error-text" };
const _hoisted_13 = { class: "col-span-2 flex items-center" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", { class: "mr-4" }, "Encryption type", -1);
const _hoisted_15 = { class: "col-span-2 flex items-center gap-4" };
const _hoisted_16 = {
    key: 0,
    class: "col-span-4 flex flex-col gap-2"
};
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("p", { class: "text-lg font-semibold" }, " Please wait while we test your settings ", -1);
const _hoisted_18 = {
    key: 1,
    class: "col-span-2 flex items-center"
};
const _hoisted_19 = {
    key: 2,
    class: "col-span-4 flex flex-col gap-4"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-semibold" }, " Invalid SMTP settings ", -1);
import { ref } from 'vue';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/yup';
import * as Yup from 'yup';
import SelectButton from 'primevue/selectbutton';
import ProgressBar from 'primevue/progressbar';
import InlineMessage from 'primevue/inlinemessage';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import { useFetch, useHandleError, useToastNotifications } from '@apparatix/composables';
import FormTextGroup from '@apparatix/library/FormTextGroup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MailServerSettings',
    props: {
        type: {},
        settings: {}
    },
    setup(__props) {
        const { post } = useFetch();
        const { showSuccess } = useToastNotifications();
        const errorHandler = useHandleError();
        const props = __props;
        const providerOptions = ref(['Apparatix server', 'My own server']);
        const smtpEncryptionOptions = ref(['SSL', 'TLS']);
        const imapEncryptionOptions = ref(['SSL/TLS', 'Insecure']);
        const selectedProvider = ref(props.settings?.server ? 'My own server' : 'Apparatix server');
        const selectedEncryptionType = ref(props.settings?.protocol ?? props.type === 'smtp' ? 'SSL' : 'SSL/TLS');
        const testErrors = ref();
        const testPassed = ref(false);
        const testInProgress = ref(false);
        const errorMap = {
            'authentication': 'Could not authenticate. Check username/password.',
            'timeout': 'Timeout when contacting SMTP Server. Check Server Address and Port Number.',
            'server-address': 'Could not find SMTP server. Is the Server Address correct?',
            'invalid-recipient': 'It looks like your email address is configured incorrectly, contact Support to get it fixed.',
            'invalid-sender': 'It looks like your email address is configured incorrectly, contact Support to get it fixed.',
            'message-error': 'Unknown error. Try again.',
            'send-error': 'Unknown error. Try again.',
            'unknown': 'Unknown error. Try again.',
        };
        const { errors, defineField, handleSubmit, meta } = useForm({
            validationSchema: toTypedSchema(Yup.object({
                server: Yup.string().required(),
                username: Yup.string().required(),
                password: Yup.string(),
                port: Yup.string().required().matches(/^[0-9]+$/, 'Port must be a number').min(2).max(5),
            })),
            initialValues: {
                server: props.settings?.server,
                username: props.settings?.user,
                port: props.settings?.port,
            },
        });
        const [server, serverAttrs] = defineField('server');
        const [username, usernameAttrs] = defineField('username');
        const [password, passwordAttrs] = defineField('password');
        const [port, portAttrs] = defineField('port');
        const getValues = () => ({
            server: server.value,
            username: username.value,
            password: password.value,
            port: port.value,
            protocol: selectedEncryptionType.value,
            type: props.type,
            useCustom: selectedProvider.value === 'My own server',
        });
        const testSettings = async () => {
            testInProgress.value = true;
            testPassed.value = false;
            testErrors.value = [];
            const data = getValues();
            const result = await post('/account-settings/test-smtp', data);
            if (result.success) {
                testPassed.value = true;
                testErrors.value = [];
            }
            else {
                testPassed.value = false;
                if (Array.isArray(result.errors)) {
                    testErrors.value = result.errors;
                }
                else {
                    testErrors.value = ['Something went wrong'];
                }
            }
            testInProgress.value = false;
        };
        const saveSettings = async () => {
            const data = getValues();
            const result = await post('/account-settings/save-email-settings', data);
            if (result.success) {
                showSuccess(`Your ${props.type} settings have been successfully saved`, 'Success');
            }
            else {
                errorHandler.handleError({
                    message: `Error saving your ${props.type} settings`,
                    showToast: true,
                    toastDetail: 'We encountered an error saving your settings. Please try again or contact support if the problem persists',
                });
            }
        };
        const onSubmit = handleSubmit(() => saveSettings());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(props.type), 1),
                _createElementVNode("p", null, [
                    _createTextVNode("Configure your own "),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(props.type), 1),
                    _createTextVNode(" server for outbound mail, or use ours")
                ]),
                _createVNode(_unref(SelectButton), {
                    modelValue: selectedProvider.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedProvider).value = $event)),
                    options: providerOptions.value
                }, null, 8, ["modelValue", "options"]),
                (selectedProvider.value === 'My own server')
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        onSubmit: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
                    }, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(FormTextGroup, { class: "col-span-2" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("label", null, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(props.type), 1),
                                        _createTextVNode(" server address")
                                    ]),
                                    _createVNode(_unref(InputText), _mergeProps({
                                        modelValue: _unref(server),
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(server) ? (server).value = $event : null))
                                    }, _unref(serverAttrs), {
                                        "aria-label": "Server address",
                                        invalid: !!_unref(errors).server,
                                        placeholder: props.type === 'smtp' ? 'smtp.gmail.com' : 'imap.gmail.com'
                                    }), null, 16, ["modelValue", "invalid", "placeholder"]),
                                    _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(errors).server), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(FormTextGroup, { class: "col-span-2" }, {
                                default: _withCtx(() => [
                                    _hoisted_7,
                                    _createVNode(_unref(InputText), _mergeProps({
                                        modelValue: _unref(port),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(port) ? (port).value = $event : null))
                                    }, _unref(portAttrs), {
                                        "aria-label": "Server port",
                                        placeholder: "465, 587",
                                        invalid: !!_unref(errors).port
                                    }), null, 16, ["modelValue", "invalid"]),
                                    _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(errors).port), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(FormTextGroup, { class: "col-span-2" }, {
                                default: _withCtx(() => [
                                    _hoisted_9,
                                    _createVNode(_unref(InputText), _mergeProps({
                                        modelValue: _unref(username),
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(username) ? (username).value = $event : null))
                                    }, _unref(usernameAttrs), {
                                        placeholder: "example@gmail.com",
                                        "aria-label": "Server username",
                                        invalid: !!_unref(errors).username
                                    }), null, 16, ["modelValue", "invalid"]),
                                    _createElementVNode("small", _hoisted_10, _toDisplayString(_unref(errors).username), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(FormTextGroup, { class: "col-span-2" }, {
                                default: _withCtx(() => [
                                    _hoisted_11,
                                    _createVNode(_unref(Password), _mergeProps({
                                        modelValue: _unref(password),
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(password) ? (password).value = $event : null)),
                                        "input-props": { class: 'w-full' },
                                        feedback: false,
                                        invalid: !!_unref(errors).password,
                                        "toggle-mask": ""
                                    }, _unref(passwordAttrs), { "aria-label": "Server password" }), null, 16, ["modelValue", "invalid"]),
                                    _createElementVNode("small", _hoisted_12, _toDisplayString(_unref(errors).password), 1)
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                (props.type === 'smtp')
                                    ? (_openBlock(), _createBlock(_unref(SelectButton), {
                                        key: 0,
                                        modelValue: selectedEncryptionType.value,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedEncryptionType).value = $event)),
                                        options: smtpEncryptionOptions.value
                                    }, null, 8, ["modelValue", "options"]))
                                    : _createCommentVNode("", true),
                                (props.type === 'imap')
                                    ? (_openBlock(), _createBlock(_unref(SelectButton), {
                                        key: 1,
                                        modelValue: selectedEncryptionType.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedEncryptionType).value = $event)),
                                        options: imapEncryptionOptions.value
                                    }, null, 8, ["modelValue", "options"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(Button), {
                                    label: "Save settings",
                                    type: "submit",
                                    disabled: !_unref(meta).valid || !_unref(meta).dirty
                                }, null, 8, ["disabled"]),
                                (props.type === 'smtp')
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 0,
                                        severity: 'secondary',
                                        label: "Test SMTP settings",
                                        disabled: !_unref(meta).valid,
                                        onClick: testSettings
                                    }, null, 8, ["disabled"]))
                                    : _createCommentVNode("", true)
                            ]),
                            (testInProgress.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _hoisted_17,
                                    _createVNode(_unref(ProgressBar), {
                                        mode: "indeterminate",
                                        style: { "height": "5px" }
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (testPassed.value && _ctx.type === 'smtp')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_unref(InlineMessage), { severity: "success" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" SMTP settings are valid ")
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (!!testErrors.value && testErrors.value.length !== 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createElementVNode("p", null, "The settings you provided are invalid. We encountered the following " + _toDisplayString(testErrors.value.length === 1 ? 'error' : 'errors'), 1),
                                    _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testErrors.value, (error) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: error,
                                                class: "error-text"
                                            }, _toDisplayString(errorMap[error]), 1));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 32))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
